import { getAcceptedOfferBudget } from './payouts';
import { renderPrice } from './helper/price';

import type { Subcampaign } from 'types';

export function getCampaignAgreedBudget(agreedSubcampaigns: Array<Subcampaign>): number {
  // `budget` can be `null`
  return agreedSubcampaigns.reduce((sum, next) => sum + getAcceptedOfferBudget(next), 0);
}

export function getDisplayBudget(budget: number): string {
  let value: number | string = budget;

  if (budget > Math.floor(value)) {
    value = budget.toFixed(2);
  }
  return renderPrice(value);
}
